import type { RememberLastAgentIdParams } from './types';

const LAST_AGENT_ID_STORAGE_KEY = 'voxity.lastAgentId';

const rememberLastAgentId = ({ agentId }: RememberLastAgentIdParams): void => {
    sessionStorage.setItem(LAST_AGENT_ID_STORAGE_KEY, agentId);
};

export default rememberLastAgentId;
export { LAST_AGENT_ID_STORAGE_KEY };
